/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconArrowTopRight is deprecated and will be archived soon. Use IconArrowTopRight instead.
 */

export function Experimental__IconArrowTopRight(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path fill-rule='evenodd' d='M12.696 3.776L3.883 12.59l-.472-.47 8.813-8.814.472.471z' clip-rule='evenodd'/><path fill-rule='evenodd' d='M12.127 3.874l-6.794-.007V3.2l7.46.007.014 7.46h-.667l-.013-6.793z' clip-rule='evenodd'/>"
  }, {
    size: 24,
    svgContent: "<path fill-rule='evenodd' d='M19.044 5.664l-13.22 13.22-.708-.707 13.22-13.22.708.707z' clip-rule='evenodd'/><path fill-rule='evenodd' d='M18.19 5.81L8 5.8v-1l11.19.01.02 11.19-1 .001-.02-10.191z' clip-rule='evenodd'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M14 2v7.75a.75.75 0 01-1.5 0V4.56l-8.62 8.62a.75.75 0 11-1.06-1.06l8.619-8.62h-5.19a.75.75 0 010-1.5H14z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M19 5v10.193a1 1 0 11-2 0V8.414L5.707 19.707a1 1 0 01-1.414-1.414L15.586 7H8.808a1 1 0 010-2H19z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconArrowTopRight;